import { Injectable } from '@angular/core';
import { PHBHPApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/lib/ph-bhp-api.service';

@Injectable({
  providedIn: 'root'
})
export class PHBHPFeaturePackageConsumptionService {

  constructor(private service: PHBHPApiService) { }

  getDepartmentDetails(id) {
    return this.service.getApi('Departments/GetDepartmentById/' + id, true);
  }
  getDepartmentList() {
    return this.service.getApi('Departments/GetDepartments', true);
  }
  getWardsbyInstitutionId(id) {
    return this.service.getApi('ManageInstitution/GetInstituionWards/' + id, true);
  }
  createConsumption(data) {
    return this.service.postApi('Consumptions', data, true)
  }
  createNewConsumption(data) {
    return this.service.postApi('Consumptions/Consumptions/CheckConsumptionInserted', data, true)
  }
  getConsumption() {
    return this.service.getApi('Consumptions', true);
  }
  getConsumptionID(id) {
    return this.service.getApi('Consumptions/' + id, true);
  }
  getwardByID(id) {
    return this.service.getApi('Wards/' + id, true);
  }
  createConsumptionPeriod(data) {
    return this.service.postApi('ConsumptionPeriods/CreateMultipleConsumptionPeriod', data, true);
  }
  getConsumptionPeriod() {
    return this.service.getApi('ConsumptionPeriods', true)
  }
  getConsumptionConfig() {
    return this.service.getApi('ConsumptionConfigs', true);
  }
  getConsumptionConfigByInstitutionId(id) {
    let url = 'ObserveObservation/GetGeneralConfigurationByInstitutionId/' + id
    return this.service.getApi(url, true);
  }
  getConsumptionById(id) {
    return this.service.getApi('Consumptions/' + id, true);
  }
  getConsumptionPeriodById(id) {
    return this.service.getApi('ConsumptionPeriods/' + id, true);
  }
  //  getConsumptionPeriodListByConsumptionId(id) {
  //    return this.service.getApi('Consumptions/GetConsumptionByInstitutionId/'+ id, true);
  //  }
  getConsumptionPeriodListByConsumptionId(id) {
    return this.service.getApi('SOPConsumption/GetConsumptionByInstitutionId/' + id, true);
  }
  getSOPConsumptionByConsumptionId(id) {
    return this.service.getApi('SOPConsumption/GetSOPConsumptionList/' + id, true);
  }
  updateConsumptionPeriodById(id, data) {
    return this.service.putApi('ConsumptionPeriods/UpdateMultipleConsumptionPeriod/' + id, data, true);
  }
  getWardsAndDepartments(id) {
    return this.service.getApi('SOPEvaluation/GetWardsAndDepartments/' + id, true);
  }

  /**
 * Gets consumption year configuration
 * @param consumptionConfig
 * @param year
 * @returns Current year configuration or oldest configuration if there's no specific configuration for consumption date (for older consumptions)
 */
  getConsumptionYearConfiguration(consumptionConfig: any[], year: number) {
    let consumptionYearConfig: any
    if (consumptionConfig && year) {
      consumptionYearConfig = consumptionConfig.find(config => config.year == year);
      if (!consumptionYearConfig)
        consumptionYearConfig = consumptionConfig.sort(config => config.year)[0]
    }
    return consumptionYearConfig
  }

}
